import { IframeLayout } from '@karakuri-web/faq-type'

interface Props {
  layout: IframeLayout
}

/**
 * Iframeウィジェット
 * 外部コンテンツをiframeで表示する
 */
export function IframeWidget({ layout }: Props) {
  // eslint-disable-next-line jsx-a11y/iframe-has-title
  return layout.data ? <iframe className={'faq-iframe'} src={layout.data} /> : null
}
